import { GeckoComponentRect } from 'types/geometric/geckoComponentRect'

/**
 * This base class for Gecko markup primitives ensures a base level of common
 * functionality and also allows for "instanceof GeckoMarkupPrimitive"
 */
export abstract class GeckoMarkupPrimitive {
  //----------------------------------------------------------------------------

  public readonly id: string
  public abstract readonly kind: string
  public readonly markupLayerID: string
  public readonly bounds: GeckoComponentRect

  protected constructor(
    id: string,
    markupLayerID: string,
    bounds: GeckoComponentRect
  ) {
    this.id = id
    this.markupLayerID = markupLayerID
    this.bounds = bounds
  }

  //----------------------------------------------------------------------------

  public get componentID() {
    return this.bounds.componentID
  }
}
